export default "__VITE_ASSET__DPHuacRR__"